export default {
      id: "cycling_indoor-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#cycling_indoor",
      toString: function () {
        return this.url;
      }
    }